import { createBrowserRouter } from 'react-router-dom';

import { commonRoutes } from './common.routes';
import { instructRoutes } from './instruct.routes';
import { manageRoutes } from './manage.routes';
import { catchAllRoute, publicRoutes } from './public.routes';
import { trainRoutes } from './train.routes';

/**
 * Main application router
 *
 * Route organization:
 * - public.routes.tsx    → Landing, Cookie Policy, Error pages
 * - common.routes.tsx    → App initializer, Selectors, Visitor home
 * - train.routes.tsx     → /train/* (Trainee module)
 * - instruct.routes.tsx  → /instruct/* (Instructor module)
 * - manage.routes.tsx    → /manage/:customerId/* (Manager module)
 *
 * Guard stack order (when applicable):
 * 1. AuthenticatedRoute → User must be logged in
 * 2. OrgRouteGuard      → Validate org access (for /manage routes)
 * 3. FeatureFlagGuard   → Check if feature is enabled
 * 4. PermissionGuard    → Check user has required permission
 *
 * @see docs/ROUTE_ARCHITECTURE.md for detailed documentation
 */
const router = (): ReturnType<typeof createBrowserRouter> => {
  const browserRouter = createBrowserRouter([
    // Public routes (landing, errors, cookie policy)
    ...publicRoutes,

    // Common authenticated routes (app-init, selectors, visitor home)
    ...commonRoutes,

    // Module-specific routes
    ...manageRoutes,
    ...trainRoutes,
    ...instructRoutes,

    // Catch-all must be last
    ...catchAllRoute,
  ]);

  return browserRouter;
};

export { router };
